<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@3.0.0 planets.glb -k -u -s -t
-->

<script lang="ts">
  import type * as THREE from 'three'
  import { Group } from 'three'
  import type { Snippet } from 'svelte'
  import { T, type Props } from '@threlte/core'
  import { useGltf, useGltfAnimations, useSuspense } from '@threlte/extras'
  import { Button, Folder, Pane } from 'svelte-tweakpane-ui'

  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    ...props
  }: Props<THREE.Group> & {
    ref?: THREE.Group
    children?: Snippet<[{ ref: THREE.Group }]>
    fallback?: Snippet
    error?: Snippet<[{ error: Error }]>
  } = $props()

  const suspend = useSuspense()
  let animating = $state(false)

  ref = new Group()

  type ActionName = 'Sun' | 'FirstPlanet' | 'ThirdPlanet' | 'SecondPlanet'
  type GLTFResult = {
    nodes: {
      Sphere: THREE.Mesh
      Sphere001: THREE.Mesh
      Sphere003: THREE.Mesh
      Sphere002: THREE.Mesh
    }
    materials: {
      solarsystem: THREE.MeshStandardMaterial
    }
  }

  const gltf = suspend(useGltf<GLTFResult>('/models/planets.glb'))
  export const { actions, mixer } = useGltfAnimations<ActionName>(gltf, ref)

  const sunAction = $derived($actions?.Sun)
  const firstPlanetAction = $derived($actions?.FirstPlanet)
  const secondPlanetAction = $derived($actions?.SecondPlanet) 
  const thirdPlanetAction = $derived($actions?.ThirdPlanet)

  $effect(() => {
    if (sunAction && firstPlanetAction && secondPlanetAction && thirdPlanetAction) {
      sunAction.play()
      firstPlanetAction.play()
      secondPlanetAction.play()
      thirdPlanetAction.play()
      animating = true
    }
  })
</script>

<T
  is={ref}
  dispose={false}
  {...props}
>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group name="Scene" scale={0.4}>
      <T.Mesh
        name="Sphere"
        castShadow
        receiveShadow
        geometry={gltf.nodes.Sphere.geometry}
        material={gltf.materials.solarsystem}
        position={[-0.04, 0.04, -0.1]}
        scale={1}
      />
      <T.Mesh
        name="Sphere001"
        castShadow
        receiveShadow
        geometry={gltf.nodes.Sphere001.geometry}
        material={gltf.materials.solarsystem}
        position={[-0.04, 0.04, -0.1]}
        scale={0.5}
      />
      <T.Mesh
        name="Sphere003"
        castShadow
        receiveShadow
        geometry={gltf.nodes.Sphere003.geometry}
        material={gltf.materials.solarsystem}
        position={[-0.04, 0.04, -0.1]}
        scale={0.5}
      />
      <T.Mesh
        name="Sphere002"
        castShadow
        receiveShadow
        geometry={gltf.nodes.Sphere002.geometry}
        material={gltf.materials.solarsystem}
        position={[-0.04, 0.04, -0.1]}
        scale={0.5}
      />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}

  {@render children?.({ ref })}
</T>
